import CreateForwardingDirectiveEntryFormStep from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStep'
import { MaintenanceForwardingsRequiredDirectiveStepsData } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { directiveEntryFormSteps } from '../constants/directiveEntryFormSteps.constant'

interface CreateForwardingDirectiveEntryFormStepsProps {
  requiredDirectiveSteps: MaintenanceForwardingsRequiredDirectiveStepsData
}

const CreateForwardingDirectiveEntryFormSteps = ({
  requiredDirectiveSteps,
}: CreateForwardingDirectiveEntryFormStepsProps) => {
  const stepKeys = Object.keys(requiredDirectiveSteps) as Array<keyof MaintenanceForwardingsRequiredDirectiveStepsData>

  return (
    <div className="flex flex-col gap-3">
      {stepKeys.map((key, index) => {
        const directiveEntry = directiveEntryFormSteps[key]

        return (
          <CreateForwardingDirectiveEntryFormStep
            key={key}
            directiveEntryData={directiveEntry}
            attributes={requiredDirectiveSteps[key]}
            index={index}
          />
        )
      })}
    </div>
  )
}

export default CreateForwardingDirectiveEntryFormSteps
